(() => {
  if (window.__lbFiltersDrawerBound) return;
  window.__lbFiltersDrawerBound = true;

  const mq = () => window.matchMedia('(max-width:1023px)').matches;

  const open = () => {
    if (!mq()) return;
    document.body.classList.add('lb-filters-open');
    const btn = document.querySelector('[data-lb-filters-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  };

  const close = () => {
    document.body.classList.remove('lb-filters-open');
    const btn = document.querySelector('[data-lb-filters-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-lb-filters-open]')) {
      e.preventDefault();
      document.body.classList.contains('lb-filters-open') ? close() : open();
      return;
    }
    if (e.target.closest('[data-lb-filters-close]') || e.target.closest('[data-lb-filters-backdrop]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  window.addEventListener('resize', () => {
    if (!mq()) close();
  });
})();
